<div class="header-topnav mat-elevation-z2">
  <div class="container">
    <div class="topnav">
      <!-- App Logo -->
      <div class="topbar-branding">
        <img src="assets/images/matx.png" alt="" class="app-logo">
      </div>

      @if (!layoutConf.isMobile) {
        <ul class="menu">
          @for (item of menuItems; track item; let i = $index) {
            <li>
              @if (item.type !== 'separator') {
                <div routerLinkActive="open">
                  @if (item.type === 'link') {
                    <a matRipple routerLink="/{{item.state}}">
                      <mat-icon>{{item.icon}}</mat-icon>
                      {{item.name }}
                    </a>
                  }
                  @if (item.type === 'dropDown') {
                    <div>
                      <label matRipple for="drop-{{i}}" class="toggle"><mat-icon>{{item.icon}}</mat-icon> {{item.name }}</label>
                      <a matRipple><mat-icon>{{item.icon}}</mat-icon> {{item.name }}</a>
                      <input type="checkbox" id="drop-{{i}}" />
                      <ul>
                        @for (itemLvL2 of item.sub; track itemLvL2; let j = $index) {
                          <li routerLinkActive="open">
                            @if (itemLvL2.type !== 'dropDown') {
                              <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}/{{itemLvL2.state}}"
                                >
                                @if (itemLvL2.icon) {
                                  <mat-icon>{{itemLvL2.icon}}</mat-icon>
                                }
                                {{itemLvL2.name }}
                              </a>
                            }
                            @if (itemLvL2.type === 'dropDown') {
                              <div>
                                <label matRipple for="drop-{{i}}{{j}}" class="toggle">{{itemLvL2.name }}</label>
                                <a matRipple>@if (itemLvL2.icon) {
                                  <mat-icon>{{itemLvL2.icon}}</mat-icon>
                                }  {{itemLvL2.name }}</a>
                                <input type="checkbox" id="drop-{{i}}{{j}}" />
                                <!-- Level 3 -->
                                <ul>
                                  @for (itemLvL3 of itemLvL2.sub; track itemLvL3) {
                                    <li routerLinkActive="open">
                                      <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}{{itemLvL2.state ? '/'+itemLvL2.state : ''}}/{{itemLvL3.state}}">
                                        @if (itemLvL3.icon) {
                                          <mat-icon>{{itemLvL3.icon}}</mat-icon>
                                        }
                                        {{itemLvL3.name }}
                                      </a>
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              }
            </li>
          }
        </ul>
      }
      <span fxFlex></span>
      <!-- End Navigation -->
      <!-- Language Switcher -->
      @if (!layoutConf.isMobile) {
        <mat-select
          placeholder=""
          id="langToggle"
          [style.width]="'auto'"
          name="currentLang"
          [(ngModel)]="currentLang"
          (selectionChange)="setLang()"
          class="topbar-button-right">
          @for (lang of availableLangs; track lang) {
            <mat-option
            [value]="lang.code" ngDefaultControl>{{ lang.name }}</mat-option>
          }
        </mat-select>
      }

      <!-- Theme Switcher -->
      <button mat-icon-button
        id="schemeToggle"
        [style.overflow]="'visible'"
        matTooltip="Color Schemes"
        [matMenuTriggerFor]="themeMenu"
        class="topbar-button-right">
        <mat-icon>format_color_fill</mat-icon>
      </button>
      <mat-menu #themeMenu="matMenu">
        <mat-grid-list class="theme-list"
          cols="2"
          rowHeight="48px">
          @for (theme of matxThemes; track theme) {
            <mat-grid-tile
              (click)="changeTheme(theme)">
              <div mat-menu-item [title]="theme.name">
                <div [style.background]="theme.baseColor" class="matx-swatch"></div>
                @if (theme.isActive) {
                  <mat-icon class="active-icon">check</mat-icon>
                }
              </div>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </mat-menu>

      <!-- Notification toggle button -->
      <button mat-icon-button
        matTooltip="Notifications"
        (click)="toggleNotific()"
        [style.overflow]="'visible'"
        class="topbar-button-right">
        <mat-icon>notifications</mat-icon>
        <span class="notification-number mat-bg-warn">3</span>
      </button>

      <!-- Top left user menu -->
      <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="topbar-button-right mr-16 img-button">
        <img src="assets/images/face-7.jpg" alt="">
      </button>
      <mat-menu #accountMenu="matMenu">
        <button mat-menu-item [routerLink]="['/profile/overview']">
          <mat-icon>account_box</mat-icon>
          <span>Profile</span>
        </button>
        <button mat-menu-item [routerLink]="['/profile/settings']">
          <mat-icon>settings</mat-icon>
          <span>Account Settings</span>
        </button>
        <button mat-menu-item>
          <mat-icon>notifications_off</mat-icon>
          <span>Disable alerts</span>
        </button>
        <button mat-menu-item>
          <mat-icon>exit_to_app</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>

      <!-- Mobile screen menu toggle -->
      @if (layoutConf.isMobile) {
        <button mat-icon-button
          class="mr-16"
          (click)="toggleSidenav()"
          >
          <mat-icon>menu</mat-icon>
        </button>
      }

    </div>
  </div>
</div>
